import { useSortable } from "@dnd-kit/sortable";

import type { Column } from "../../Table.types";

/**
 * Hook to get the sortable object for the column
 * @param column
 *
 * @returns sortable object
 */
export const useInternalTableDndSortable = <
  TableData extends Record<string, any>
>(
  column: Column<TableData>
) => {
  const draggleSortingObject = useSortable({
    id: column.id
  });

  return draggleSortingObject;
};
